module.exports = __webpack_public_path__ + "img/serve5.33e43c0f.png";